import { useQuery } from '@tanstack/react-query';

import { FEATURE_FLAGS } from '~/modules/experiments/features';
import { useFeatureFlags } from '~/modules/experiments/hooks/useFeatureFlags';

import { RoleQueryKeys } from '../config/queryKeys';
import { BFFClient } from '../lib/BFFClient';
import {
  type UserTypeListResponse,
  UserTypeListResponseSchema,
} from '../lib/schemas';
import type { PresetUseQueryOptions } from '../lib/types';

const OLD_USER_TYPES: UserTypeListResponse = {
  total: 2,
  page: 1,
  totalPages: 1,
  data: [
    { id: 'internal', name: 'INTERNAL' },
    { id: 'external', name: 'EXTERNAL' },
  ],
};

export function useUserTypes<TData extends UserTypeListResponse>(
  options?: PresetUseQueryOptions<UserTypeListResponse, TData>,
) {
  const [isInternalUserUpdatesEnabled] = useFeatureFlags([
    FEATURE_FLAGS.SettingsInternalUserUpdates,
  ]);

  const { data: userTypes, ...query } = useQuery({
    queryKey: RoleQueryKeys.types(),
    queryFn: async () => {
      if (!isInternalUserUpdatesEnabled) {
        return OLD_USER_TYPES;
      }

      const responseData = await BFFClient.get('user-types').json();

      return UserTypeListResponseSchema.parse(responseData);
    },
    ...options,
  });

  return { userTypes, ...query };
}
